<template>
  <div class="house-tree-container">
    <ResizableContainer :initial-width="400" height="calc(100vh - 280px)">
      <ProjectTree :project_id="mainObj.project_id" @node-click="nodeClick" />
    </ResizableContainer>

    <div class="house-tree-list">
      <div class="house-tree-list-header">
        <el-button type="primary" size="mini" @click="$refs.houseInfoComponent.show({})">添加房产</el-button>
      </div>
      <HeaderTip>
        房产数：{{pageData.total}}
      </HeaderTip>
      <el-table
        :data="pageData.data"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%" height="calc(100vh - 320px)">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          fixed
          prop="ancestor_name"
          label="房产名称"
          width="320">
        </el-table-column>
        <el-table-column
          prop="house.charging"
          label="计费面积"
          width="120">
        </el-table-column>
        <el-table-column
          prop="type"
          label="房产类型"
          width="100">
          <template slot-scope="scope">
            <span>{{house_type[scope.row.type]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="house.room_status_name"
          label="房态"
          width="100">
        </el-table-column>
        <el-table-column
          prop="customer.name"
          label="业主"
          width="100">
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="label"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="$refs.houseInfoComponent.show(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="house-tree-list-footer">
        <el-pagination
          layout="prev, pager, next"
          :total="pageData.total"
          :current-page="pageData.current_page"
          :page-size="pageData.per_page"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
    <HouseInfoComponent ref="houseInfoComponent" />
    <HouseRelatedInfo ref="houseRelatedInfo" />
  </div>
</template>

<script>
import ResizableContainer from "../../../Common/ResizableContainer";
import ProjectTree from "../../../Common/ProjectTree";
import Http from "../../../Project/common/Http";
import HeaderTip from "../../../Common/header-tip";
import HouseInfoComponent from "./components/HouseInfoComponent";
import HouseRelatedInfo from "./components/HouseRelatedInfo";

export default {
  name: "HouseTree",
  components: {HouseRelatedInfo, HouseInfoComponent, HeaderTip, ProjectTree, ResizableContainer},
  inject: ['mainObj'],
  data() {
    return {
      pageData: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
        data: [],
      },
      loading:false,
      treeData:{},
      house_type:{
        0:"空",
        1:"住宅",
        2:"车位",
        3:"储藏室",
        4:"商铺",
      }
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    nodeClick(data) {
      // console.log(data);
      this.treeData=data;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList(){
      const that = this;
      that.loading=true;
      Http.get("HouseTree/getHouseList",{
        project_id:that.treeData.erp_pindex_id||89,
        parent_id:that.treeData.house_id,
        page:that.pageData.current_page,
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=Object.assign({
            total: 0,
            per_page: 20,
            current_page: 1,
            last_page: 1,
            data: [],
          },ret.data);
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    pageChange(page=1){
      const that=this;
      that.pageData.current_page=page;
      that.getList();
    },
    remove(row){
      const that=this;
      that.$refs.houseRelatedInfo.show(row,()=>{
        that.getList();
      });

    }
  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.house-tree-container{
  display: flex;
  flex-direction: row;

  .house-tree-list{
    width: calc(100% - 400px);
    height: calc(100vh - 220px);
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/HouseTree.vue